import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { Tooltip, Dialog, DialogContent, WithStyles, withStyles, Typography, IconButton, Button, DialogActions, Box } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import FilterListIcon from '@material-ui/icons/FilterList';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { FeedbackType, RowData } from 'src/reducers/feedbackRequest';
import { CSVLink } from 'react-csv';

interface TableState {
    columns: Array<Column<FeedbackType>>;
    data: FeedbackType[];
}

export interface FeedbackPageProps {
    feedbackData: FeedbackType[];
    fbOrderView: (orderno: string, dsorderid: string) => void;
    fbOrderRated: (orderno: string, dsorderid: string) => void;
    dateFilter: (filterStartdate: Date, filterEnddate: Date) => void;
    dateReset: (filterStartdate: Date, filterEnddate: Date) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        buttonSend1: {
            // margin: theme.spacing(1),
            // float: 'right',
            // zIndex: 100,
            marginRight: '12px',
            // position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dialog: {
            margin: theme.spacing(2)
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        exportButton: {
            textDecoration: 'none',
            fontSize: '0.4rem',
            '&:hover': {
                textDecoration: 'none'
            },
            '&:link': {
                textDecoration: 'none'
            }
        },
        exportIcon: {
            fontSize: '20px',
            fill: 'white'
        }
    })
);

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onCloseD: () => void;
}

const DialogTitle = withStyles(styles)((propss: DialogTitleProps) => {
    const { children, onCloseD, classes, ...other } = propss;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onCloseD ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onCloseD}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export const FeedbackView: React.StatelessComponent<FeedbackPageProps> = (props) => {
    const classes = useStyles({});

    const [dialogOpen, setdialogOpen] = React.useState(true);

    const getThreeMonthsBack = (date: Date) => {
        date.setMonth(new Date().getMonth() - 3);
        return date;
    };

    const [filterStartdate, setFilterStartDate] = React.useState(getThreeMonthsBack(new Date()));
    const [filterEnddate, setFilterEndDate] = React.useState(new Date());

    const changeStartDate = (date: Date) => {
        setFilterStartDate(date);
    };
    const changeEndDate = (date: Date) => {
        setFilterEndDate(date);
    };

    const handleCloseDialog = () => {
        setdialogOpen(false);
    };

    const handleClickDialog = () => {
        setdialogOpen(true);
    };

    const submitDialog = () => {
        props.dateFilter(filterStartdate, filterEnddate);
        setdialogOpen(false);
    };

    const reload = () => {
        props.dateFilter(filterStartdate, filterEnddate);
    };

    const resetDialog = () => {
        props.dateReset(new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)), new Date());
        setdialogOpen(false);
    };
    
    const [state] = React.useState<TableState>({
        columns: [
            { title: 'Date', field: 'createdon' },
            { title: 'Feedback ID', field: 'feedbackid',
                render: (rowData: RowData) => (
                    <div 
                        onClick={() => props.fbOrderRated(rowData.orderno, rowData.ds_ordersid)} 
                        style={{ cursor: 'pointer', color: '#4960e1', textDecoration: 'underline' }}
                    >
                        {rowData.feedbackid}
                    </div>
                )
            },
            { 
                title: 'Order No',
                field: 'orderno', 
                cellStyle: {
                    fontSize: '12px'
                },
                render: (rowData: RowData) => (
                    <div 
                        onClick={() => props.fbOrderView(rowData.orderno, rowData.ds_ordersid)} 
                        style={{ cursor: 'pointer', color: '#4960e1', textDecoration: 'underline' }}
                    >
                        {rowData.orderno}
                    </div>
                )
            },
            // { title: 'Booking ID', field: 'refno', cellStyle: { fontSize: '12px' } },
            { title: 'File Name', field: 'fname', cellStyle: { fontSize: '12px' } },
            { title: 'Destination', field: 'destination', cellStyle: { fontSize: '12px' } },
            { title: 'Design Software', field: 'tool_preferred', cellStyle: { fontSize: '12px' } },
            { title: 'Design Approval', field: 'designapproval', cellStyle: { fontSize: '12px' } },
            { title: 'Feedback Type', field: 'feedbacktype', cellStyle: { fontSize: '12px' } },
            { title: 'Rating', field: 'rating', cellStyle: { fontSize: '12px' } },
            { title: 'Design Center Comments', field: 'reviewcomments', cellStyle: { fontSize: '12px' } },
            { title: 'Closed On', field: 'closedon', cellStyle: { fontSize: '12px' } },
        ],
        data: props.feedbackData
    });

    const tableHeaders = [
        { label: 'Date', key: 'createdon' },
        { label: 'Order No', key: 'orderno' },
        // { label: 'Booking ID', key: 'refno' },
        { label: 'File Name', key: 'fname' },
        { label: 'Destination', key: 'destination' },
        { label: 'Design Software', key: 'tool_preferred' },
        { label: 'Design Approval', key: 'designapproval' },
        { label: 'Feedback Type', key: 'feedbacktype' },
        { label: 'Rating', key: 'rating' },
        { label: 'Design Center Comments', key: 'reviewcomments' },
        { label: 'Closed On', key: 'closedon' },
    ];

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Box className={classes.buttonSend}>
                            <Tooltip title="Export" placement="top" arrow>
                                <Button
                                    id="Export"
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="contained"
                                    color="primary"
                                    className={classes.buttonSend1}
                                >
                                    <CSVLink
                                        data={props.feedbackData}
                                        // enclosingCharacter={``}
                                        headers={tableHeaders}
                                        filename={'Feedback Report.csv'}
                                        className={classes.exportButton}
                                        // target="_blank"
                                    >
                                        <FileCopyIcon className={classes.exportIcon} /> 
                                    </CSVLink>
                                </Button>
                            </Tooltip>
                            <Tooltip title="Filter" placement="top" arrow>
                                <Button
                                    id="filterDate"
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleClickDialog}
                                >
                                    <FilterListIcon />
                                </Button>
                            </Tooltip>
                        </Box>
                        <MaterialTable
                            title="Feedback"
                            columns={state.columns}
                            data={props.feedbackData}
                            localization={{
                                header: {
                                    actions: ''
                                }
                            }}
                            options={{
                                pageSizeOptions: [5, 10, 25, 50, 100],
                                sorting: true,
                                actionsColumnIndex: -1,
                                headerStyle: {
                                    backgroundColor: '#757575',
                                    color: '#fff',
                                    padding: '5px 10px',
                                }
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-payment-history-title" onCloseD={handleCloseDialog}><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Date Filter</Typography></DialogTitle>
                <DialogContent>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div>
                            <Grid container justify="space-around" spacing={2}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Start Date"
                                    format="MM/dd/yyyy"
                                    value={filterStartdate}
                                    onChange={changeStartDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                            <Grid container justify="space-around" spacing={2}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog-2"
                                    label="End Date"
                                    format="MM/dd/yyyy"
                                    value={filterEnddate}
                                    onChange={changeEndDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                        </div>
                    </MuiPickersUtilsProvider>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        className={classes.HeadinG}
                        onClick={submitDialog}
                    >
                        Submit
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        color="secondary"
                        onClick={resetDialog}
                        className={classes.HeadinG}
                    >
                        Reset
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default FeedbackView;



// WEBPACK FOOTER //
// ./src/components/layouts/FeedbackRequestPageView.tsx